function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import withStyles from 'isomorphic-style-loader/withStyles';
import delay from 'lodash/delay';
import find from 'lodash/find';
import get from 'lodash/get';
import { FormattedMessage, injectIntl } from 'react-intl';
import cn from 'classnames';
import { AppContext } from 'context';
import { getSlug } from 'helpers/urlTools';
import Avatar from 'components/Avatar';
import Link from 'components/Link';
import Button from 'components/Form/Button';
import intlShape from 'shapes/intlShape';
import Account from 'modules/Account';
import Information from 'modules/Information';
import App from 'modules/App';
import AccountSettings from 'svg/account-settings.svg';
import ChevronRight from 'svg/chevron-right.svg';
import Logout from 'svg/logout.svg';
import Settings from 'svg/settings.svg';
import Swap from 'svg/swap.svg';
import ClinicSettings from 'svg/clinic-settings.svg';
import AccountDeleteCheck from 'modules/Layout/components/MainLayout/TopBar/ProfileMenu/AccountDeleteCheck';
import messages from '../../../../messages';
import * as constants from '../../../../constants';
import styles from './ProfileMenu.pcss';
var _React_Component;
class ProfileMenu extends (_React_Component = React.Component) {
    async onOpenMenu(evt) {
        evt.preventDefault();
        const isOpenMenu = this.props.openDropdownId === constants.TOPBAR_AVATAR_DROPDOWN;
        await this.props.onCloseDropdown();
        if (!isOpenMenu) {
            this.props.onOpenDropdown(constants.TOPBAR_AVATAR_DROPDOWN);
        }
    }
    async onSignOut() {
        await this.props.onCloseDropdown();
        delay(this.props.onSignOut, 150); // wait for animation
    }
    get isActiveClinicAdmin() {
        const { activeProfileType, activeClinicMembership } = this.props;
        const isActiveProfileHcp = activeProfileType === Account.constants.PROFILE_TYPES.HCP;
        if (!activeClinicMembership || !isActiveProfileHcp) {
            return false;
        }
        const { isAdmin = false } = activeClinicMembership;
        return isAdmin;
    }
    get activeClinicMembershipSettingsHref() {
        const clinic = get(this.props, 'activeClinicMembership.clinic', {});
        const { organizationUID } = clinic;
        const clinicSlug = getSlug(clinic.name);
        const clinicSettingHref = this.context.getUrl('clinic-settings', {
            clinicSlug,
            organizationUID
        });
        return clinicSettingHref;
    }
    get mainRouteHref() {
        const { isHcpAccount } = this.props;
        if (isHcpAccount) {
            const clinic = get(this.props, 'activeClinicMembership.clinic', {});
            const { organizationUID } = clinic;
            const clinicSlug = getSlug(clinic.name);
            const clinicSettingHref = this.context.getUrl('general-population', {
                clinicSlug,
                organizationUID
            });
            return clinicSettingHref;
        }
        return this.context.getUrl('my-results');
    }
    get countryName() {
        const { countryCode: alpha2Code } = this.props.account;
        const country = find(this.props.countries, {
            alpha2Code
        });
        return get(this.props.localizationResources, [
            country.nameKey,
            'value'
        ], country.englishName);
    }
    get imageFile() {
        const { countryCode } = this.props.account;
        return `${countryCode}.svg`;
    }
    get profileName() {
        const { scope } = this.props.account;
        return this.props.intl.formatMessage(Account.messages.scopes[scope]);
    }
    get isGoToCncVisible() {
        const { account } = this.props;
        return account.scope === Account.constants.SCOPE_NAMES.PROFESSIONAL && account.countryCode === 'us';
    }
    renderHeader() {
        const { firstName, lastName } = this.props.information || {};
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.dropdown__profileContainer,
            "data-testid": "profile-info",
            children: [
                this.renderAvatar(),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.dropdown__profileContent,
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            className: "brand__paragraph--bold",
                            children: `${firstName} ${lastName}`
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "brand__paragraph d-flex align-items-center",
                            children: [
                                /*#__PURE__*/ _jsx("figure", {
                                    className: styles.dropdown__flagContainer,
                                    children: /*#__PURE__*/ _jsx("img", {
                                        className: styles.dropdown__flag,
                                        src: `/aid/assets/svg/flags/${this.imageFile}`,
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    "data-testid": "profile-details",
                                    children: [
                                        this.countryName,
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text--muted text--normal mx-3",
                                            children: "|"
                                        }),
                                        this.profileName
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    renderSwitchProfile() {
        return /*#__PURE__*/ _jsx("li", {
            className: styles.dropdownMenu__action,
            children: /*#__PURE__*/ _jsxs(Button, {
                id: "switch-profile",
                onClick: this.props.onSwitchProfile,
                className: styles.menuItem,
                children: [
                    /*#__PURE__*/ _jsx(Swap, {}),
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.topBar.buttons.switchProfile))
                ]
            })
        });
    }
    // TODO change route to profile-settings
    renderProfileSettings() {
        return /*#__PURE__*/ _jsx("li", {
            className: styles.dropdownMenu__action,
            children: /*#__PURE__*/ _jsxs(Button, {
                id: "profile-settings",
                type: "link",
                to: this.context.getUrl('account-settings'),
                className: styles.menuItem,
                children: [
                    /*#__PURE__*/ _jsx(Settings, {}),
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.topBar.buttons.profileSettings))
                ]
            })
        });
    }
    renderClinicSettings() {
        if (!this.isActiveClinicAdmin) {
            return null;
        }
        return /*#__PURE__*/ _jsx("li", {
            className: styles.dropdownMenu__action,
            children: /*#__PURE__*/ _jsxs(Button, {
                id: "clinic-settings",
                type: "link",
                to: this.activeClinicMembershipSettingsHref,
                className: styles.menuItem,
                children: [
                    /*#__PURE__*/ _jsx(ClinicSettings, {}),
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.topBar.buttons.clinicSettings))
                ]
            })
        });
    }
    renderAccountSettings() {
        return /*#__PURE__*/ _jsx("li", {
            className: styles.dropdownMenu__action,
            children: /*#__PURE__*/ _jsxs(Button, {
                id: "account-settings",
                className: styles.menuItem,
                onClick: this.props.onEditAccount,
                children: [
                    /*#__PURE__*/ _jsx(AccountSettings, {}),
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.topBar.buttons.accountSettings))
                ]
            })
        });
    }
    renderFeatureToggle() {
        if (!this.props.featureToggles.includes(App.constants.FEATURE_TOGGLES.featurePlatforms)) {
            return null;
        }
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.dropdown__separator
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: cn('brand__caption--bold', styles.dropdown__header),
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.topBar.headers.yourApplications))
                }),
                /*#__PURE__*/ _jsxs("ul", {
                    className: "dropdownMenu__actions",
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: styles.dropdownMenu__action,
                            children: /*#__PURE__*/ _jsxs(Button, {
                                type: "link",
                                to: this.mainRouteHref,
                                className: styles.menuItem,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: styles.dropdown__activeDot
                                    }),
                                    /*#__PURE__*/ _jsx("img", {
                                        src: "/assets/svg/gc_logo.svg",
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.topBar.buttons.gc))
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: styles.dropdownMenu__action,
                            children: /*#__PURE__*/ _jsxs(Button, {
                                type: "link",
                                to: this.context.bls.cnc,
                                className: styles.menuItem,
                                children: [
                                    /*#__PURE__*/ _jsx("img", {
                                        src: "/assets/svg/cnc_logo.svg",
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.topBar.buttons.cnc))
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
    renderLogout() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.dropdown__separator
                }),
                /*#__PURE__*/ _jsx("ul", {
                    className: "dropdownMenu__actions",
                    children: /*#__PURE__*/ _jsx("li", {
                        className: styles.dropdownMenu__action,
                        children: /*#__PURE__*/ _jsxs(Button, {
                            id: "logout-btn",
                            onClick: ()=>this.onSignOut(),
                            className: styles.menuItem,
                            children: [
                                /*#__PURE__*/ _jsx(Logout, {}),
                                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.topBar.buttons.logout))
                            ]
                        })
                    })
                })
            ]
        });
    }
    renderGoToCnc() {
        if (!this.isGoToCncVisible) {
            return null;
        }
        return /*#__PURE__*/ _jsx("li", {
            className: styles.dropdownMenu__action,
            children: /*#__PURE__*/ _jsxs(Button, {
                type: "link",
                to: this.context.bls.cnc,
                className: styles.menuItem,
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        src: "/assets/img/cnc.png",
                        alt: "Contour Next Concierge"
                    }),
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.topBar.buttons.cnc))
                ]
            })
        });
    }
    renderMenu() {
        if (this.props.openDropdownId !== constants.TOPBAR_AVATAR_DROPDOWN) {
            return null;
        }
        return /*#__PURE__*/ _jsxs(motion.div, {
            initial: {
                height: 0
            },
            animate: {
                height: 'auto'
            },
            exit: {
                height: 0
            },
            transition: {
                ease: 'easeOut',
                duration: 0.15
            },
            className: styles.dropdown,
            "data-testid": "profile-menu-opened",
            children: [
                this.renderHeader(),
                /*#__PURE__*/ _jsxs("ul", {
                    className: "dropdownMenu__actions",
                    children: [
                        this.renderSwitchProfile(),
                        this.renderProfileSettings(),
                        this.renderAccountSettings(),
                        this.renderClinicSettings(),
                        this.renderGoToCnc()
                    ]
                }),
                this.renderFeatureToggle(),
                this.renderLogout()
            ]
        });
    }
    renderAvatar() {
        const { firstName, lastName, avatar } = this.props.information || {};
        return /*#__PURE__*/ _jsx(Avatar, {
            avatarImg: avatar,
            name: [
                firstName,
                lastName
            ],
            className: styles.avatar,
            imgClassName: styles.avatar__img,
            initialsClassName: styles.avatar__initials
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.container,
            "data-testid": "profile-menu",
            children: [
                /*#__PURE__*/ _jsxs(Link, {
                    to: "",
                    className: styles.profileMenu,
                    onClick: (evt)=>this.onOpenMenu(evt),
                    children: [
                        this.renderAvatar(),
                        /*#__PURE__*/ _jsx(ChevronRight, {})
                    ]
                }),
                /*#__PURE__*/ _jsx(AnimatePresence, {
                    children: this.renderMenu()
                }),
                /*#__PURE__*/ _jsx(AccountDeleteCheck, {})
            ]
        });
    }
}
_define_property(ProfileMenu, "contextType", AppContext);
_define_property(ProfileMenu, "propTypes", {
    // Implicit props
    account: Account.shapes.account,
    activeProfile: PropTypes.shape({
        avatar: PropTypes.string
    }),
    activeProfileType: Account.shapes.profileType.isRequired,
    activeClinicMembership: Account.shapes.clinicMembership,
    information: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        avatar: PropTypes.string
    }),
    isHcpAccount: PropTypes.bool.isRequired,
    countries: PropTypes.arrayOf(App.shapes.country),
    openDropdownId: PropTypes.string,
    localizationResources: PropTypes.object,
    featureToggles: PropTypes.arrayOf(PropTypes.string),
    intl: intlShape.isRequired,
    // Implicit actions
    onEditAccount: PropTypes.func,
    onSwitchProfile: PropTypes.func,
    onOpenDropdown: PropTypes.func,
    onCloseDropdown: PropTypes.func,
    onSignOut: PropTypes.func
});
const mapStateToProps = (state)=>({
        account: Account.selectors.account(state),
        activeClinicMembership: Account.selectors.activeClinicMembership(state),
        isHcpAccount: Account.selectors.isHcpAccount(state),
        activeProfile: Account.selectors.activeProfile(state),
        activeProfileType: Account.selectors.activeProfileType(state),
        information: Information.selectors.information(state),
        countries: App.selectors.countries(state),
        openDropdownId: App.selectors.dropdown(state),
        localizationResources: App.selectors.localizationResources(state),
        featureToggles: App.selectors.featureToggles(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onOpenDropdown: (dropdownId)=>dispatch(App.actions.openDropdown(dropdownId)),
        onCloseDropdown: ()=>dispatch(App.actions.closeDropdown()),
        onEditAccount: ()=>dispatch(Account.actions.editAidAccount()),
        onSwitchProfile: ()=>dispatch(Account.actions.switchProfile()),
        onSignOut: ()=>dispatch(Account.actions.signOut())
    });
const ConnectedProfileMenu = connect(mapStateToProps, mapDispatchToProps)(injectIntl(ProfileMenu));
export default withStyles(styles)(ConnectedProfileMenu);
